import React from "react";
import { STATUS_META, SPONSOR_STATES, CATEGORY_NAME } from "../constants";

export const Dot = ({ color }) => (
  <span className="w-1.5 h-1.5 rounded-full shrink-0" style={{ backgroundColor: color }} />
);

export const Pill = ({ color, children, title }) => (
  <span
    className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded text-xs font-medium whitespace-nowrap"
    style={{ backgroundColor: `${color}22`, color }}
    title={title}
  >
    <Dot color={color} />
    {children}
  </span>
);

export const StatusBadge = ({ status }) => {
  const meta = STATUS_META[status] || { label: status || "Unknown", color: "#888888" };
  return <Pill color={meta.color}>{meta.label}</Pill>;
};

export const SponsorBadge = ({ state, title }) => {
  if (!state || state === "none") return <span className="text-gray-500">-</span>;
  const meta = SPONSOR_STATES[state] || SPONSOR_STATES.none;
  return <Pill color={meta.color} title={title}>{meta.label}</Pill>;
};

export const CategoryChips = ({ categories }) => {
  const list = Array.isArray(categories) ? categories : [];
  if (list.length === 0) return <span className="text-gray-500">-</span>;
  return (
    <div className="flex flex-wrap gap-1 max-w-[220px]">
      {list.map((c) => (
        <span key={c} className="inline-flex px-1.5 py-0.5 rounded text-[0.7rem] bg-gray-700 text-gray-200 whitespace-nowrap">
          {CATEGORY_NAME[c] || c}
        </span>
      ))}
    </div>
  );
};

// Token logo with a symbol-initials fallback when the image is missing or fails.
export const TokenLogo = ({ url, symbol, size = 28 }) => {
  const [failed, setFailed] = React.useState(false);
  React.useEffect(() => setFailed(false), [url]);
  const safe = typeof url === "string" && /^https:\/\//i.test(url) ? url : "";
  if (safe && !failed) {
    return (
      <img
        src={safe}
        alt=""
        width={size}
        height={size}
        className="rounded-full object-cover bg-gray-800 shrink-0"
        style={{ width: size, height: size }}
        onError={() => setFailed(true)}
      />
    );
  }
  const initials = String(symbol || "?").slice(0, 3).toUpperCase();
  return (
    <span
      className="inline-flex items-center justify-center rounded-full bg-bl-accent/20 text-bl-accent-light font-semibold shrink-0"
      style={{ width: size, height: size, fontSize: Math.max(9, Math.round(size / 3)) }}
      aria-hidden="true"
    >
      {initials}
    </span>
  );
};
